// @flow
import React, { useRef } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Drawer from '@material-ui/core/Drawer';
import { SECTION } from '../../constants/appConstants';
import Options from '../Options';
import TargetInspector from '../TargetInspector';
import Zones from '../Zones';
import Targets from '../Targets';
import Alerts from '../Alerts';
import { SidebarProvider } from './context';


const drawerWidth = 440;

const useStyles = makeStyles(theme => ({
    drawer: {
        width: drawerWidth,
    },
    drawerPaper: {
        marginTop: 64,
        width: drawerWidth,
        height: 'calc(100% - 64px)',
        backgroundColor: theme.palette.background.paper,
        boxShadow: theme.shadows[4]
    },
    drawerHeader: {
        display: 'flex',
        alignItems: 'center',
        padding: theme.spacing(0, 1),
        ...theme.mixins.toolbar,
        justifyContent: 'flex-end'
    },
    toolbar: theme.mixins.toolbar
}));

type Props = $ReadOnly<{
    drawerOpen: boolean,
    activeSection: typeof SECTION
}>;

function Sidebar({ drawerOpen, activeSection }: Props) {
    const classes = useStyles();
    const paperRef = useRef();

    const isActive = (section) => section === activeSection;

    return (
        <Drawer
            className={classes.drawer}
            classes={{
                paper: classes.drawerPaper
            }}
            variant="persistent"
            PaperProps={{ ref: paperRef }}
            open={drawerOpen}
        >
            <SidebarProvider width={drawerWidth} paperRef={paperRef}>
                {isActive(SECTION.options) && <Options />}
                {isActive(SECTION.zones) && <Zones />}
                {isActive(SECTION.targets) && <Targets />}
                {isActive(SECTION.targetInspector) && <TargetInspector />}
                {isActive(SECTION.alerts) && <Alerts />}
            </SidebarProvider>
        </Drawer>
    );
}

export default Sidebar;